

export function NearestPointOnRoute(
  driver: google.maps.LatLngLiteral,
  route: google.maps.LatLngLiteral[]
): { point: google.maps.LatLngLiteral; distance: number } {
  let nearestPoint = route[0];
  let minDistance = Number.MAX_VALUE;

  for (let i = 0; i < route.length - 1; i++) {
    const segmentStart = route[i];
    const segmentEnd = route[i + 1];
    const candidate = projectPointOnSegment(driver, segmentStart, segmentEnd);
    const distance = haversineDistance(driver, candidate);

    if (distance < minDistance) {
      minDistance = distance;
      nearestPoint = candidate;
    }
  }

  return { point: nearestPoint, distance: minDistance };
}



function haversineDistance(a: google.maps.LatLngLiteral, b: google.maps.LatLngLiteral): number {
  const R = 6371000; // meters
  const toRad = (x: number) => (x * Math.PI) / 180;

  const dLat = toRad(b.lat - a.lat);
  const dLng = toRad(b.lng - a.lng);

  const lat1 = toRad(a.lat);
  const lat2 = toRad(b.lat);

  const h =
    Math.sin(dLat / 2) ** 2 +
    Math.sin(dLng / 2) ** 2 * Math.cos(lat1) * Math.cos(lat2);

  return 2 * R * Math.asin(Math.sqrt(h));
}

function projectPointOnSegment(
  p: google.maps.LatLngLiteral,
  a: google.maps.LatLngLiteral,
  b: google.maps.LatLngLiteral
): google.maps.LatLngLiteral {
  const A = { x: a.lng, y: a.lat };
  const B = { x: b.lng, y: b.lat };
  const P = { x: p.lng, y: p.lat };

  const AB = { x: B.x - A.x, y: B.y - A.y };
  const AP = { x: P.x - A.x, y: P.y - A.y };

  const ab2 = AB.x * AB.x + AB.y * AB.y;
  const ap_ab = AP.x * AB.x + AP.y * AB.y;
  let t = ap_ab / ab2;

  t = Math.max(0, Math.min(1, t)); // clamp to [0,1]

  return { lat: A.y + AB.y * t, lng: A.x + AB.x * t };
}